import React from 'react'
import PropTypes from 'prop-types'

import { _VerifyEmailCard, _CardTitle, _AppButtonCta } from './styles'

const VerifyEmailCard = ({ openEmailVerifyModal }) => (
  <_VerifyEmailCard data-test-id="heroVerifyEmailCard">
    <_CardTitle>Verify your email to view listing images.</_CardTitle>
    <_AppButtonCta
      primary
      medium
      onClick={openEmailVerifyModal}
      isLoginStyle
    >
      Verify
    </_AppButtonCta>
  </_VerifyEmailCard>
)


export default VerifyEmailCard

VerifyEmailCard.propTypes = {
  openEmailVerifyModal: PropTypes.func,
}
